import { FindStoresEffect } from './find-stores.effect';
import { ViewAllStoresEffect } from './view-all-stores.effect';

export const effects: any[] = [FindStoresEffect, ViewAllStoresEffect];

export * from './find-stores.effect';
export * from './view-all-stores.effect';
